export const testimonials = [
    {
        id: 1,
        name: 'Rasheed Ahmed',
        company: 'Malabar Spices Trading',
        role: 'Proprietor',
        content: 'NAQD Consulting transformed our business accounting. Their GST compliance services saved us from penalties and their tax planning reduced our liability by 35%. The team is responsive and understands the spice trading business well.',
        rating: 5,
        service: 'GST Compliance & Tax Planning',
        location: 'Malappuram',
        clientSince: '2020',
        verified: true,
    },
    {
        id: 2,
        name: 'Dr. Suresh Kumar',
        company: 'Kerala Dental Care',
        role: 'Managing Director',
        content: 'As a healthcare provider, we needed specialized accounting support. NAQD helped us optimize equipment depreciation and manage complex billing. Their understanding of medical practice accounting is exceptional.',
        rating: 5,
        service: 'Healthcare Accounting',
        location: 'Kozhikode',
        clientSince: '2019',
        verified: true,
    },
    {
        id: 3,
        name: 'Fatima Beevi',
        company: 'FB Textiles',
        role: 'Managing Partner',
        content: 'Excellent service for our textile business. They handle our multi-location GST filing, inventory accounting, and seasonal tax planning. Very professional and always available when we need them.',
        rating: 5,
        clientSince: '2022',
        verified: true,
    },
    {
        id: 6,
        name: 'Sreelatha Menon',
        company: 'Green Valley Developers',
        role: 'Finance Head',
        content: 'Real estate accounting is complex, but NAQD made it simple. Their project-wise accounting and RERA compliance support helped us manage 5 ongoing projects efficiently. Highly recommended!',
        rating: 5,
        service: 'Real Estate Accounting',
        location: 'Thrissur',
        clientSince: '2020',
        verified: true,
    },
    {
        id: 7,
        name: 'Abdul Khader',
        company: 'Malabar Logistics',
        role: 'Operations Manager',
        content: 'Transportation business has unique challenges. NAQD\'s fuel tax optimization and e-way bill management saved us ₹8 lakhs annually. Their team understands logistics accounting perfectly.',
        rating: 5,
        service: 'Transportation Accounting',
        location: 'Malappuram',
        clientSince: '2019',
        verified: true,
    },
    {
        id: 8,
        name: 'Priya Nair',
        company: 'Kerala Ayurveda Exports',
        role: 'Export Manager',
        content: 'Export business requires meticulous documentation. NAQD handles our export incentives, GST refunds, and customs compliance flawlessly. Their expertise saved us significant time and money.',
        rating: 5,
        service: 'Export Accounting & Compliance',
        location: 'Kozhikode',
        clientSince: '2021',
        verified: true,
    },
    {
        id: 9,
        name: 'Hameed Ibrahim',
        company: 'Malabar Gold Traders',
        role: 'Partner',
        content: 'Jewelry business has specific tax requirements. NAQD\'s understanding of gold trading taxation and compliance is excellent. They help us stay compliant while optimizing our tax position.',
        rating: 5,
        service: 'Jewelry Business Accounting',
        location: 'Malappuram',
        clientSince: '2017',
        verified: true,
    },
    {
        id: 10,
        name: 'Vineeth Kumar',
        company: 'Digital Marketing Pro',
        role: 'Founder',
        content: 'As a digital service provider, I needed help with GST on international clients and professional tax. NAQD simplified everything and helped me focus on growing my business.',
        rating: 5,
        service: 'Professional Services Tax',
        location: 'Kochi',
        clientSince: '2022',
        verified: true,
    },
];

export const getTestimonialById = (id) => {
    return testimonials.find(testimonial => testimonial.id === id);
};

export const getTestimonialsByService = (service) => {
    return testimonials.filter(testimonial =>
        testimonial.service.toLowerCase().includes(service.toLowerCase())
    );
};

export const getVerifiedTestimonials = () => {
    return testimonials.filter(testimonial => testimonial.verified);
};

export const getAverageRating = () => {
    const total = testimonials.reduce((sum, testimonial) => sum + testimonial.rating, 0);
    return (total / testimonials.length).toFixed(1);
};
